import { FrameworkControlStatus } from "../../framework/frameworks/Frameworks.types";
import { maxAiDocumentSizeInBytes } from "@common/components/dotLegalFileUpload/maxDocumentSize";

export enum PolicyVersionStatus {
    Draft = 1,
    Approved = 2,
}

export interface PolicyControl {
    id: string;
    name: string;
    customId?: string;
    frameworkName: string;
    status: FrameworkControlStatus;
}

export interface PolicySubsection {
    id: string;
    originalSubsectionId: string;
    number: string;
    title: string | null;
    content: string | null;
    order: number;
    linkedControlIds: string[];
}

export interface PolicySection {
    id: string;
    originalSectionId: string;
    number: string;
    title: string | null;
    content: string | null;
    order: number;
    linkedControlIds: string[];
    subsections: PolicySubsection[];
}

export interface PolicySectionsResponse {
    versionId: string;
    major: number;
    minor: number;
    currentVersion: string;
    status: PolicyVersionStatus;
    isEditable: boolean;
    hasPublishedVersion: boolean;
    publishedVersionLabel: string | null;
    title: string | null;
    description: string | null;
    sections: PolicySection[];
}

export interface PolicyVersionDetailsUpdateModel {
    title: string | null;
    description: string | null;
}

export interface PolicySectionSaveModel {
    title: string | null;
    content: string | null;
    order: number;
}

export interface PolicySectionUpdateModel {
    title: string | null;
    content: string | null;
}

export interface PolicySectionReorderItem {
    sectionId: string;
    order: number;
}

export interface PolicySectionControlLinksModel {
    frameworkControlIds: string[];
}

export interface PolicySubsectionSaveModel {
    title: string | null;
    content: string | null;
    order: number;
}

export interface PolicySubsectionUpdateModel {
    title: string | null;
    content: string | null;
}

export interface PolicySubsectionReorderItem {
    subsectionId: string;
    order: number;
}

export interface PolicyImportSaveModel {
    fileName: string;
    base64Data: string;
}

export const PolicyImportLimits = {
    allowedExtensions: [".pdf", ".docx"] as const,
    maxFileSizeBytes: maxAiDocumentSizeInBytes,
};
